"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayBillService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("../../shared/services/restservice");
const http_1 = require("@angular/common/http");
const rxjs_1 = require("rxjs");
class PayBillService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.giftCardUrl = '/rest-api/account/payment/giftcard/v1/checkBalance/';
        this.submitPaymentThroughGiftCardURL = '/rest-api/account/payment/giftcard/v1/submit';
        this.savePaymentThroughGiftCardURL = '/rest-api/account/payment/giftcard/v1/save/';
        this.savedBankDetailUrl = '/rest-api/account/payment/bank/v1/savedDetails/';
        this.saveBankAccountDetailsUrl = '/rest-api/account/payment/bank/v1/save/';
        this.submitBankAccountDetailsUrl = '/rest-api/account/payment/bank/v1/submit';
        this.bankAvailabilityCheckUrl = '/rest-api/account/payment/bank/v1/isAvailable/';
        this.getGenericContentCheckPayPOBoxWarningUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=/generic/instructional/CheckPayPOBoxWarning';
        this.getGenericContentcheckPayTemporarilyDisabledUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=/generic/instructional/checkPayTemporarilyDisabled';
        this.getTenderFeeUrl = '/rest-api/account/payment/thirdparty/v1/getTenderFee';
    }
    getGiftCardBalanceDetails(giftCardNumber, giftCardPin) {
        const inputArgs = new http_1.HttpParams().set('giftCardNo', giftCardNumber)
            .set('pin', giftCardPin);
        return this.post(this.giftCardUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getSavedBankDetails() {
        return this.get(this.savedBankDetailUrl).pipe(operators_1.map((data) => data));
    }
    saveBankAccountDetails(content) {
        return this.post(this.saveBankAccountDetailsUrl, content, true).pipe(operators_1.map((data) => data));
    }
    submitBankAccountDetails(content, eqmAccNumber, invoiceAccount) {
        let submitUrl;
        if (eqmAccNumber) {
            submitUrl = this.submitBankAccountDetailsUrl + '?equipment=' + eqmAccNumber;
        }
        else if (invoiceAccount) {
            submitUrl = this.submitBankAccountDetailsUrl + '?invoiceAccount=' + invoiceAccount;
        }
        else {
            submitUrl = this.submitBankAccountDetailsUrl + '/';
        }
        return this.post(submitUrl, content, true).pipe(operators_1.map((data) => data));
    }
    checkBankAvailabilityOption() {
        return this.get(this.bankAvailabilityCheckUrl).pipe(operators_1.map((data) => data));
    }
    savePaymentByGiftCard(content) {
        return this.post(this.savePaymentThroughGiftCardURL, content, true).pipe(operators_1.map((data) => data));
    }
    submitPaymentByGiftCard(content, eqmAccNumber, invoiceAccount) {
        let submitUrl;
        if (eqmAccNumber) {
            submitUrl = this.submitPaymentThroughGiftCardURL + '?equipment=' + eqmAccNumber;
        }
        else if (invoiceAccount) {
            submitUrl = this.submitPaymentThroughGiftCardURL + '?invoiceAccount=' + invoiceAccount;
        }
        else {
            submitUrl = this.submitPaymentThroughGiftCardURL + '/';
        }
        return this.post(submitUrl, content, true).pipe(operators_1.map((data) => data));
    }
    genericContentCheckBoxPayByBank() {
        return this.get(this.getGenericContentCheckPayPOBoxWarningUrl).pipe(operators_1.map((data) => data));
    }
    genericContentPayTemporarilyDisabled() {
        return this.get(this.getGenericContentcheckPayTemporarilyDisabledUrl).pipe(operators_1.map((data) => data));
    }
    getServiceFee(tenderFeeRequest) {
        return this.post(this.getTenderFeeUrl, tenderFeeRequest, true).pipe(operators_1.map((data) => data));
    }
}
exports.PayBillService = PayBillService;
//# sourceMappingURL=paybill.service.js.map